import { ArticleHeader } from "@chaos/website-frontend";

export default ArticleHeader;
